import {Record, Map} from "immutable"
import {Users, JsonData as UserJsonData, fromJs as userFromJs} from "./User"

interface Properties {
    id: number
    abbreviation: string
    crmAccessRequested: boolean
    confirmed: boolean
    region: string
    city: string
    demandHold: boolean
    demandBuildingLocked: boolean
    demandLocked: boolean
    crmExported: boolean
    crmPrinted: boolean
    crmSentResult: boolean
    isBuilding: boolean
    hasBuildingDemands: boolean
    isOpk: boolean
    users?: Users
}

export class Company extends Record({
    id: undefined,
    abbreviation: undefined,
    crmAccessRequested: undefined,
    confirmed: undefined,
    region: undefined,
    city: undefined,
    demandHold: undefined,
    demandBuildingLocked: undefined,
    demandLocked: undefined,
    crmExported: undefined,
    crmPrinted: undefined,
    crmSentResult: undefined,
    isBuilding: undefined,
    isOpk: undefined,
    hasBuildingDemands: undefined,
    users: undefined,
}) implements Properties {
    id: number
    abbreviation: string
    crmAccessRequested: boolean
    confirmed: boolean
    region: string
    city: string
    demandHold: boolean
    demandBuildingLocked: boolean
    demandLocked: boolean
    crmExported: boolean
    crmPrinted: boolean
    crmSentResult: boolean
    isBuilding: boolean
    hasBuildingDemands: boolean
    isOpk: boolean
    users: Users | undefined

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    abbreviation: string
    crmAccessRequested: boolean
    confirmed: boolean
    region: string
    city: string
    demandHold: boolean
    demandBuildingLocked: boolean
    demandLocked: boolean
    crmExported: boolean
    crmPrinted: boolean
    crmSentResult: boolean
    isBuilding: boolean
    hasBuildingDemands: boolean
    isOpk: boolean
    users?: UserJsonData[]
}

export const fromJs = ({
    id,
    abbreviation,
    crmAccessRequested,
    confirmed,
    region,
    city,
    demandHold,
    demandBuildingLocked,
    demandLocked,
    crmExported,
    crmPrinted,
    crmSentResult,
    isBuilding,
    hasBuildingDemands,
    users,
    isOpk,
}: JsonData): Company => {
    let data: Properties = {
        id,
        abbreviation,
        crmAccessRequested,
        confirmed,
        region,
        city,
        demandHold,
        demandBuildingLocked,
        demandLocked,
        crmExported,
        crmPrinted,
        crmSentResult,
        isBuilding,
        isOpk,
        hasBuildingDemands,
    }

    if (users) {
        data.users = <Users>Map(users.map(user => [user.id, userFromJs(user)]))
    }

    return new Company(data)
}

export type Companies = Map<number, Company>